import {Separator, Actions, Action} from 'platform/components';
import {Box, Integer, Space, VStack, useDevice} from 'platform/foundation';

import {MAIN_SIDEBAR_WIDTH} from '@dms/shared';

import {Nullish, TestIdProps} from 'shared/web';

import {PROFILE_SIDEBAR_WIDTH} from './MyProfileTemplate/MyProfileTemplate';

export interface MyProfileFooterProps extends TestIdProps {
  actions: Action[] | Nullish;
}

export function MyProfileFooter(props: MyProfileFooterProps) {
  const device = useDevice();
  const isSmallDevice = device === 'mobile' || device === 'tablet';

  const leftOffset = isSmallDevice
    ? PROFILE_SIDEBAR_WIDTH
    : ((PROFILE_SIDEBAR_WIDTH + MAIN_SIDEBAR_WIDTH) as Integer);

  return (
    <>
      <Space vertical={20} />
      <Box
        position="fixed"
        right={0}
        bottom={0}
        left={leftOffset}
        backgroundColor="general.white"
        zIndex="CONTENT"
      >
        <VStack>
          <Separator spacing={0} />
          <Box padding={6}>
            <Actions actions={props.actions} align="right" />
          </Box>
        </VStack>
      </Box>
    </>
  );
}
